import React from "react";

const ServiceContent = ({ product }) => {
  return (
    <div className="serviceContent_hexagon  col-md-12">
      <div className={`serviceContent_shape ${"serviceContent_" + product.id} ` }>
        <div className="serviceContent_cover">
          <div className="serviceContent_miniHex">
            <div style = {{backgroundColor:product.bg}} className="serviceContent_miniShape">
              <img
                style={{ height: "120 px", width: "95px" }}
                className="serviceContent_icon"
                src={product.icon}
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="serviceContent_info">
          <div className="serviceContent_detail">
            <h3 className="serviceContent_h3">{product.title}</h3>
            {product.content.map((d, i) => (
              <p key={i + 1} className="serviceContent_p">
                {d}
              </p>
            ))}
          </div>
        </div>
      </div>
      {/* <img src={img4} alt="" /> */}
    </div>
  );
};

export default ServiceContent;
